export default __webpack_public_path__ + "locales/sl/People.json?hash=e67c6cd358b7a8357d35a7895f87ec63";